(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-contact-paths"] && !Shopify.designMode) return;
  try {
    
  // Single controlled scroll: the native <a href="#contact-form"> jump is
  // intentionally suppressed (preventDefault) so this is the only scroll
  // that runs — no double-scroll from anchor navigation plus a separate
  // scrollIntoView(). #contact-form's own scroll-margin-top (set in
  // page-contact-form.liquid) accounts for the sticky header, so a plain
  // scrollIntoView() lands correctly without hardcoding an offset here.
  document.addEventListener('click', (event) => {
    const card = event.target.closest('[data-inquiry-type]')
    if (!card) return

    const target = document.getElementById('contact-form')
    if (!target) return

    event.preventDefault()

    const select = target.querySelector('select[name="contact[inquiry_type]"]')
    if (select) {
      const value = card.getAttribute('data-inquiry-type')
      const hasOption = Array.from(select.options).some((option) => option.value === value)
      if (hasOption) {
        select.value = value
        select.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' })

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#contact-form')
    }

    // Calling focus() while a smooth-scroll animation is still in flight
    // cancels that animation partway through, so focus is deferred until
    // the scroll has settled — via the scrollend event where supported,
    // falling back to a timeout matched to the smooth-scroll duration for
    // browsers that don't yet support scrollend. Either way, preventScroll
    // still guards against focus causing its own (now-redundant) jump.
    if (select) {
      if (prefersReducedMotion) {
        select.focus({ preventScroll: true })
      } else {
        // Race scrollend against a timeout fallback — whichever comes
        // first wins — so focus always lands even if this browser never
        // fires scrollend for this particular scroll (e.g. very short
        // distances, or other edge cases some engines don't cover).
        let focused = false
        const focusOnce = () => {
          if (focused) return
          focused = true
          select.focus({ preventScroll: true })
        }
        if ('onscrollend' in window) {
          window.addEventListener('scrollend', focusOnce, { once: true })
        }
        window.setTimeout(focusOnce, 600)
      }
    }
  })

  } catch(e) { console.error(e); }
})();
})();
